import React, { useState, useEffect, useRef } from 'react'
import { Carousel, Divider, Button } from 'antd';
import { Link, useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'
import { createBanner } from "../../functions/deal"
import JBannerM from "../../images/JBannerM.jpg"
import JBannerDesk from "../../images/JBannerDesk.jpg"
import curfewMob from "../../images/curfewMob.jpg"
import curfewDesk from "../../images/curfewDesk.jpg"
import './customBanner.css'

import { getAllBanners } from "../../functions/banner"

import {
    LeftCircleOutlined
} from "@ant-design/icons";

const Banner = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 700px)' })

    const [banner, setBanner] = useState([]);

    const carousel = useRef();
    const [slides, setSlides] = useState([]);


    useEffect(() => {
        loadBanners();
    }, []);




    const loadBanners = () => {
        getAllBanners().then((c) => {
            let arr = []
            c.data.map((u) => {
                if (u.live == 'Yes') {
                    if (localStorage.getItem("DeliveryType") == 'Shipping') {
                        if (u.shipping == 'Yes') {
                            arr.push(u)
                        }
                    } else {
                        arr.push(u)
                    }
                }
            })
            setBanner((prev) => arr)
        });
    }

    const handleNext = () => {
        carousel.current.next()
    }

    const handleChange = (a, b) => {
        console.log(a, b);
    }

    return (
        <div>
            <Carousel autoplay ref={ref => {

                carousel.current = ref;
            }}>

                {banner.map((b) => (
                    <div key={b._id}>
                        <Link to={`${b.link}`}>
                            {isTabletOrMobile ? (
                                <div className="margin-bottom--one pdl-generic-content_container--max">
                                    <div tabIndex={-1} className="pdl-carousel_item _carousel-item" style={{ width: '100%' }}>
                                        <div className="kwm-tile_spyglass spyglass-nav-group_wrapper">
                                            <div className={`kwm-tile kwm-colors--${b.color ? b.color : 'primary'} link-pointer`}>
                                                <div className="kwm-tile_image-container" style={{ backgroundImage: `url(${b.imgLinkMob})` }}>
                                                    {b.showMsg != false && (
                                                        <div>
                                                            <div className="kwm-message-mobile">
                                                                <div><span className="kwm-message-mobile_headline"> {b.title} </span><span className="kwm-message-mobile_bodycopy">{b.description}</span></div>
                                                                <div className="kwm-message-mobile_carot-icon">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                    <div className="margin-bottom--one pdl-generic-content_container--max">
                                        <div className="pdl-carousel_item _carousel-item" style={{ height: '', width: '100%', textAlign: 'center' }}>
                                            <div className="kwm-tile_spyglass spyglass-nav-group_wrapper">
                                                <div className={`kwm-tile kwm-colors--${b.color ? b.color : 'primary'} link-pointer`}>
                                                    <div className="kwm-tile_image-container" style={{ backgroundImage: `url(${b.imgLink})` }}>
                                                        {b.showMsg != false && (
                                                            <div className={`kwm-message_container kwm-message_container--${b.placement}`}>
                                                                <div className="kwm-message_content">
                                                                    <div className="kwm-message">
                                                                        <div className="kwm-message_headline kwm-message_headline--small">{b.title}</div>
                                                                        <div className="kwm-message_bodycopy">{b.description}</div>
                                                                        <div className="kwm-message_btn-container"><button className="btn kwm-message_btn kwm-message_btn--flat"><span>Shop Now</span></button></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </Link>
                    </div>
                ))}


                <div>
                    <Link to="/new-customer">
                        {isTabletOrMobile ? (
                            <div className="margin-bottom--one pdl-generic-content_container--max">
                                <div tabIndex={-1} className="pdl-carousel_item _carousel-item" style={{ margin: '10 10 10 0', width: '100%' }}>
                                    <div className="kwm-tile_spyglass spyglass-nav-group_wrapper">
                                        <div className="kwm-tile kwm-colors--primary link-pointer">
                                            <div className="kwm-tile_image-container" style={{ backgroundImage: `url(${JBannerM})` }}>
                                                <div>
                                                    <div className="kwm-message-mobile">
                                                        <div><span className="kwm-message-mobile_headline">Welcome to Optima</span><span className="kwm-message-mobile_bodycopy">Optimum Quality Delivered</span></div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                                <div className="margin-bottom--one pdl-generic-content_container--max">
                                    <div className="pdl-carousel_item _carousel-item" style={{ width: '100%', textAlign: 'center' }}>
                                        <div className="kwm-tile_spyglass spyglass-nav-group_wrapper">
                                            <div className="kwm-tile kwm-colors--primary link-pointer">
                                                <div className="kwm-tile_image-container" style={{ backgroundImage: `url(${JBannerDesk})` }}>
                                                    <div className="kwm-message_container kwm-message_container--left">
                                                        <div className="kwm-message_content">
                                                            <div className="kwm-message">
                                                                <div className="kwm-message_headline kwm-message_headline--small">Welcome to Optima</div>
                                                                <div className="kwm-message_bodycopy">Optimum Quality Delivered in Seconds</div>
                                                                <div className="kwm-message_btn-container"><button className="btn kwm-message_btn kwm-message_btn--flat"><span>Shop Now</span></button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </Link>
                </div>
            </Carousel>

            {/* <div className="pdl-carousel_row pdl-carousel_nav-items pdl-carousel_row pdl-carousel_nav-items--bottom-arrows">
                <button onClick={() => {carousel.current.prev()}} aria-label="Previous slide" className="pdl-carousel_bottom-trigger mr-5">
                    <div className="pdl-carousel_bottom-trigger-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-label="Previous" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className><title lang="en">Previous</title><desc /><g fill stroke="white"><polyline fill="none" strokeWidth={2} strokeLinecap="square" transform="translate(15.242750, 16.485250) rotate(-180.000000) translate(-15.242750, -16.485250)" points="11 8 19.4855 16.485 11 24.9705" /></g></svg></div></button>
                            
                            <button onClick={handleNext} aria-label="Next slide" className="pdl-carousel_bottom-trigger ml-5"><div className="pdl-carousel_bottom-trigger-icon"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Next" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className><title lang="en">Next</title><desc /><g fill stroke="white"><polyline fill="none" strokeLinecap="square" strokeWidth={2} points="13.2425 7.7575 21.728 16.2425 13.2425 24.728" /></g></svg></div></button>
            </div> */}


        </div>
    )
}

export default Banner
